module.exports = __webpack_public_path__ + "img/calendar-3.370404a6.svg";